module.exports = __webpack_public_path__ + "static/media/About.7e871994.jpg";